module.exports = __webpack_public_path__ + "static/media/doodle-jens-naie.4dc27d36.jpg";